<picture [class]="imageClass + ' image-block__image'">
  <source [srcset]="awsImageSM" media="(min-width: 1200px)" />
  <source [srcset]="awsImageMD" media="(min-width: 800px)" />
  <source [srcset]="awsImageLG" media="(min-width: 400px)" />

  <img
    [alt]="alt"
    [attr.fetchpriority]="fetchPriority"
    [attr.loading]="loading"
    [class]="imageClass + ' image-block__image'"
    [src]="awsImageSM"
    [style]="imageStyle"
    decode="async"
    layout="fill"
  />
</picture>
